import { render } from "./Zhizhi2023.vue?vue&type=template&id=44b2cd31&scoped=true"
import script from "./Zhizhi2023.vue?vue&type=script&lang=js"
export * from "./Zhizhi2023.vue?vue&type=script&lang=js"

import "./Zhizhi2023.vue?vue&type=style&index=0&id=44b2cd31&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b2cd31"]])

export default __exports__